/**
 * Title-case a name for consistent display.
 *  formatName("alex smith")  -> "Alex Smith"
 *  formatName("ALEX")        -> "Alex"
 *  formatName("alex")        -> "Alex"
 *  formatName(undefined)     -> ""
 */
export function formatName(name) {
  if (!name) return '';
  // Strip email-like inputs to local-part
  const cleaned = name.includes('@') ? name.split('@')[0] : name;
  return cleaned
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
}
